import { GroupsComponent } from './groups.component';
import { GroupDetailsComponent } from './group-details/group-details.component';
import { Routes } from '@angular/router';

export const GROUPS_ROUTES: Routes = [
    {
        path: '',
        component: GroupsComponent,
        data: { section: 'ADMIN_GROUPS_SECTION', routeAdmin: true }
    },
    {
        path: ':value',
        component: GroupDetailsComponent,
        pathMatch: 'full',
        data: { section: 'ADMIN_GROUPS_SECTION', routeAdmin: true }
    },
];
